import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getRecommendedActionTemplateById } from '@api';

export const getCoreDataSecurityActionTemplateByIdSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityActionTemplateById',
	receive: true,
	request: true,
	requestHandler: getRecommendedActionTemplateById
});
